import {
  Box, Button, Label, Text,
} from '@usealloy/component-library';
import styled from 'styled-components';

const grayStringColor = 'var(--cl-gray-600)';

export const ColumnBox = styled(Box)`
  &&& {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--cl-space-2);
  }
`;

export const GrayLabel = styled(Label)`
  &&& {
    color: ${grayStringColor};
  }
`;
export const GrayText = styled(Text)`
  &&& {
    color: ${grayStringColor};
  }
`;

export const ButtonWithMarginTop = styled(Button)<{ disabled?: boolean }>`
  &&& {
    margin-top: var(--cl-space-1);
  }
`;

export const StyledServiceOptionsFormContainer = styled(Box)`
  &&& {
    align-items: flex-start;
    justify-content: space-between;
    overflow-x: auto;
    padding: var(--cl-space-5) var(--cl-space-6);
    gap: var(--cl-space-14);
  }
`;

export const StyledLeftColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 44%;
  gap: var(--cl-space-4);
`;

export const StyledRightColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 47%;
  gap: var(--cl-space-4);
`;

export const StyledSpacer = styled.div`
  flex-grow: 1;
`;
